// @ngInject
function multiPartFilter() {
    return function(items, search, searchables, limit) {
        var out = [];

        if (limit && limit.minimumInputLength && search.searchTerm.length < limit.minimumInputLength) {
            return out;
        }

        var ks = Object.keys(search);
        var searchTerms = search[ks[0]].split(" ");
        var searchableTerms = searchables.searchableTerms;

        if (angular.isArray(items) && searchTerms[0] !== "") {
            var matchingItems = _.filter(items, function(item) {
                var searchTermsThatMatches = [];

                _.forEach(searchTerms, function(searchTerm) {
                    _.forEach(searchableTerms, function(key) {
                        if (item[key].toString().toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1 && item[key].toString() !== "[object Object]") {
                            searchTermsThatMatches.push(searchTerm);
                        }
                    });
                });

                if (searchTerms.length <= searchTermsThatMatches.length) { // If every search term is a match.
                    return true;
                } else {
                    return false;
                }
            });

            _.forEach(matchingItems, function(item) {
               out.push(item);
            });
        } else {
            // Let the output be the input untouched
            out = items;
        }

        return out;
    };
}

angular.module('filters.multiPartFilter', [])
    .filter('multiPartFilter',multiPartFilter);
